export const ip_back="https://sistema.camachoasesores.net";
export const api_key="accITsol@2024";

/*
1 polizas
2 clientes
3 siniestros
*/